import { Tooltip } from "@base-ui-components/react/tooltip"
import cx from "classnames"
import { Zap } from "lucide-react"
import { usePortalContainer } from "../hooks/usePortalContainer"

export function FastModeToggle({
    enabled,
    onChange,
    touchFriendly = false,
    showLabel = false,
    tooltipSide = "top",
}: {
    enabled: boolean
    onChange: (enabled: boolean) => void
    touchFriendly?: boolean
    showLabel?: boolean
    tooltipSide?: "top" | "bottom" | "left" | "right"
}) {
    const portalContainer = usePortalContainer()
    const button = (
        <button
            type="button"
            aria-label="Fast mode"
            aria-pressed={enabled}
            title="Fast mode"
            onClick={() => onChange(!enabled)}
            className={cx(
                "btn flex items-center justify-center bg-transparent transition-colors shrink-0",
                touchFriendly ? (showLabel ? "h-11 gap-2 border border-border px-3" : "h-11 w-11 border border-border") : "h-7 w-7 border-0",
                enabled ? "text-primary hover:bg-primary/10" : "text-muted hover:bg-base-200"
            )}
        >
            <Zap size={touchFriendly ? 16 : 13} className={enabled ? "fill-current" : undefined} />
            {showLabel && <span className="text-xs">Fast</span>}
        </button>
    )

    return (
        <Tooltip.Root delay={0}>
            <Tooltip.Trigger render={button} />
            <Tooltip.Portal container={portalContainer}>
                <Tooltip.Positioner sideOffset={6} side={tooltipSide}>
                    <Tooltip.Popup className="bg-base-300 text-base-content text-xs px-2 py-1 shadow-lg border border-border">Fast mode</Tooltip.Popup>
                </Tooltip.Positioner>
            </Tooltip.Portal>
        </Tooltip.Root>
    )
}
